import { Field } from "formik";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { ValueEditor } from "react-querybuilder";
import { convertArrayValuesToString, convertStringValuesToArray } from "../../../common/Library/commonFunctions";
import MultiSelect from "../PageComponents/RavenCustomSelect";

const multiSelectDisableStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: '#eff2f7',
    opacity: 1,
    pointerEvents: 'none'
  }),
};

class CustomValueEditor extends Component {
  constructor(props) {
    super(props);

    this.getMultiSelectValues = this.getMultiSelectValues.bind(this);
    this.handleOnMultiSelectChange = this.handleOnMultiSelectChange.bind(this);
    this.getCustomizedProps = this.getCustomizedProps.bind(this);
    this.isMultiSelectEnabled = this.isMultiSelectEnabled.bind(this);
  }


  getCustomizedProps(editorProps, isMultiSelectEnabled) {
    if(editorProps?.fieldData)
    {
      if (editorProps.fieldData.valueEditorType === "select")
      {
        editorProps.className = "rule-value form-control form-control-sm form-select form-select-sm";
      }
      else if (editorProps.fieldData.valueEditorType === "multiselect" && !isMultiSelectEnabled)
      {
        editorProps.fieldData.valueEditorType = "select";
        editorProps.type = "select";
        editorProps.className = "rule-value form-control form-control-sm form-select form-select-sm";
        editorProps.value = "";
        this.props.handleOnChange(editorProps.value);
      }
      
      if (editorProps.fieldData.valueEditorType === "select" && isMultiSelectEnabled)
      {
        editorProps.fieldData.valueEditorType = "multiselect";
        editorProps.type = "multiselect";
        editorProps.className = "query-buildre-multiselect";
        editorProps.value = "";
        this.props.handleOnChange(editorProps.value);
      }
    }
      
    return editorProps;
  }

  getMultiSelectValues(values) {
    if(!Array.isArray(values))
      return [];
    return values.map((item, idx) => ({
      label: item.label,
      value: item.name,
    }));
  }

  handleOnMultiSelectChange(values) {
      const reducedArray = "[" + convertArrayValuesToString(values, ",", "'") + "]";

      this.props.handleOnChange(reducedArray);
  }

  isMultiSelectEnabled(editorProps) {
    if(!editorProps?.fieldData?.operators)
      return false;

    const operator =  editorProps.fieldData.operators.find(i => i.name?.toUpperCase() === editorProps?.operator?.toUpperCase())

    const result = operator?.multiValueEnabled;

    return result;
  }

  render() {
    const multiSelectEnabled = this.isMultiSelectEnabled(this.props);

    const editorProps = this.getCustomizedProps({...this.props}, multiSelectEnabled);

    if (multiSelectEnabled) {
      return (
        <React.Fragment>
          <Field
            className="query-buildre-multiselect"
            name={this.props.field}
            id={this.props.field}
            isMulti={multiSelectEnabled}
            component={MultiSelect}
            options={this.getMultiSelectValues(this.props.values)}
            onChangeFunction={true}
            setOnChange={this.handleOnMultiSelectChange}
            isForQueryBuilder={true}
            values={convertStringValuesToArray(editorProps.value)}
            {...(this.props.disabled ? {multiSelectStyles: multiSelectDisableStyles}: {})}
          />
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <ValueEditor {...editorProps} />
      </React.Fragment>
    );
  }
}

CustomValueEditor.propTypes = {
  field: PropTypes.string,
  operator: PropTypes.string,
  handleOnChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  valueSource: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  fieldData: PropTypes.object, //Field
  //type: PropTypes.oneOfType([PropTypes.string, null]),
  //inputType: PropTypes.oneOfType([PropTypes.string, null]),
  values: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array //any[]
  ]),
  listsAsArrays: PropTypes.bool,
  className: PropTypes.string,
  path: PropTypes.array, //number[]
  level: PropTypes.number,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  context: PropTypes.any,
 /* validation: PropTypes.oneOfType([
    null,
    PropTypes.bool,
    PropTypes.object //ValidationResult;
  ]), */
  testID: PropTypes.string,
  //disabledRules: PropTypes.bool
};

export default CustomValueEditor;
